export interface Contact {
    id: string;
    firstname: string;
    lastname: string;
    candidatureDate: Date;
    profile?: string;
    coordinates: {
        email: string;
        phone: string;
        region: string;
    };
    evaluation: {
        rating?: number;
        status: EvaluationStatus;
        notes?: string;
    };
    cv: string;
    motivationLetter: boolean;
    responseDate?: Date;
}

export enum EvaluationStatus {
    CANDIDATURE = "CANDIDATURE",
    EN_ATTENTE = "EN_ATTENTE",
    EN_ETUDE = "EN_ETUDE",
    REMERCIEE = "REMERCIEE",
    FAVORABLE = "FAVORABLE"
}

export interface StatusContact {
    [status: string]: Contact[];
}